"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const date_fns_1 = require("date-fns");
const react_1 = require("react");
const react_final_form_1 = require("react-final-form");
const react_router_dom_1 = require("react-router-dom");
const components_1 = require("components");
const config_1 = require("config");
const context_1 = require("context");
const utils_1 = require("utils");
// Date Constants
const maxDays = 40000; // ~100 years
const minDays = new Date(); // 1 year
const TODAY = minDays;
const FROM_TODAY_MAX = (0, date_fns_1.subDays)(new Date(), maxDays); // ~100 years
const DATE_NOW = {
    month: TODAY.getMonth(),
    day: TODAY.getDate(),
    year: TODAY.getFullYear(),
};
const DATE_MAX = {
    month: FROM_TODAY_MAX.getMonth(),
    day: FROM_TODAY_MAX.getDate(),
    year: FROM_TODAY_MAX.getFullYear(),
};
const ProveFindFormOTA = ({ skipFunc, submitFunc, onSubmitFail, onSubmitSuccess, }) => {
    // Hooks
    const location = (0, react_router_dom_1.useLocation)(); // location.state
    const { analytics } = (0, react_1.useContext)(context_1.AnalyticsContext);
    // Vars
    const prefill_ota_phone = location.state?.personalInfo?.primaryPhone ?? '';
    const prefill_ota_dob = location.state?.personalInfo?.dateOfBirth ?? '';
    // State
    const [isSuccessful, setIsSuccessful] = (0, react_1.useState)(false);
    const [hasErr, setHasErr] = (0, react_1.useState)(false);
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.dob) {
                errors.dob = 'Date of Birth Required';
            }
            if (!values.phone) {
                errors.phone = 'Phone Number Required';
            }
            if (values.phone && (0, utils_1.validatePhoneNumber)(values.phone)) {
                errors.phone = 'Invalid Phone Number';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    const formSubmit = async (values) => {
        // Submitted Values
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                submitFunc({
                    phone: values.phone.replace(/[^0-9]/g, ''),
                    date_of_birth: values.dob,
                });
                // On Success
                onSubmitSuccess({});
                // Is Successful
                setIsSuccessful(true);
                return undefined;
            }
            else {
                // Error Message
                setHasErr('Form has encountered an error');
                // On Fail
                onSubmitFail({});
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    const handleSkipButton = () => {
        analytics?.track('ClickIDontHaveMobileNumber', {});
        skipFunc();
    };
    (0, react_1.useEffect)(() => {
        if (hasErr) {
            handleSkipButton();
        }
    }, [hasErr, location]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "max-width-600 margin-auto", children: [(0, jsx_runtime_1.jsx)("div", { className: "text-center", children: (0, jsx_runtime_1.jsx)("h2", { className: "font-family-bold", children: "Let's Find Your Information" }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "p-20 text-left mar-y-20", children: "Providing the below information can auto-fill your pre-qualification." }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: "form-shell", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {
                                    phone: prefill_ota_phone,
                                    dob: (0, utils_1.formatDateFromDB)(prefill_ota_dob),
                                }, onSubmit: formSubmit, validate: formValidate, render: ({ handleSubmit, pristine, submitting }) => {
                                    // Button Disabled Bool
                                    const btnDisabled = submitting || isSuccessful;
                                    return ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsx)("div", { className: "form-row align-start", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "phone", disabled: isSuccessful || prefill_ota_phone !== '', label: `Mobile Number`, component: components_1.InputPattern, allowEmptyFormatting: false, formattype: '(###)-###-####', isAllowed: (values) => {
                                                        const { floatValue, value, formattedValue } = values;
                                                        return (value.length <= 14 ||
                                                            (value === '' &&
                                                                formattedValue === '' &&
                                                                floatValue === undefined));
                                                    }, placeholder: "Enter your phone", validate: utils_1.validateRequiredField, required: true, hinttype: (0, jsx_runtime_1.jsxs)("div", { className: "input-text-hint mar-y-10", children: ["By providing your phone number, Alphaeon Credit and their service providers may contact you at any number you provide, including by autodialer, recorded or artificial voice, and text. Message frequency varies. Message and data rates may apply. For further details, refer to our", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, config_1.makePath)(config_1.PATH.LEGAL, config_1.PATH.CONSENT_AUTODIALED), target: "_blank", className: "font-weight-400", rel: "noreferrer", children: "Consent to Autodialed Calls/Texts" }), ' ', "and", ' ', (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, config_1.makePath)(config_1.PATH.LEGAL, config_1.PATH.WIRELESS_CARRIER_TERMS), target: "_blank", className: "font-weight-400", rel: "noreferrer", children: "Wireless Carrier Disclosure" }), ' ', "terms."] }) }) }), (0, jsx_runtime_1.jsx)("div", { className: "form-row align-start", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { placeholder: 'MM/DD/YYYY', name: 'dob', label: 'Date of Birth', component: components_1.InputDateMask, required: true, type: "tel", mask: Date, autofix: "pad", min: new Date(DATE_MAX.year, DATE_MAX.month, DATE_MAX.day), max: new Date(DATE_NOW.year, DATE_NOW.month, DATE_NOW.day), lazy: true, unmask: false, parse: utils_1.formatDateFromInputString }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-col text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "send-receipt-buttons", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", "data-testid": "access-form-submit-button", className: `send-receipt-modal-btn button-primary button-warn-outline ${btnDisabled ? 'is-disabled' : 'is-enabled'} ${submitting ? 'in-progress' : ''}`, "aria-disabled": btnDisabled && !(pristine || submitting), children: btnDisabled
                                                                ? isSuccessful
                                                                    ? 'Success!'
                                                                    : '...Submitting'
                                                                : `Continue` }) }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { className: "send-receipt-buttons", children: (0, jsx_runtime_1.jsx)(components_1.Button, { type: "button", "data-testid": "access-form-skip-button", onClick: handleSkipButton, className: `send-receipt-modal-btn text-red button-secondary-outline border-none`, children: "I don't have a mobile number" }) })] })] }));
                                } }) })] })] }) }));
};
exports.default = ProveFindFormOTA;
